import React, { useState, useEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import items from '../json/data.json'

const Properites = () => {
  const [group, setGroup] = useState(1)
  const [marker, setMarker] = useState(6)
  const list = items.map((item) => (
      <>
        <div key={item.id} className={item.id <= marker ? "box group" + Math.ceil(item.id/6) : "box group" + Math.ceil(item.id/6) + " is-hidden"}>
          <div className="head">
            <div>{ item.address1 }</div>
            <div>{ item.address2 }</div>
            <div>{ item.desc }</div>
            <hr />
          </div>
          <figure className={"ani2 group" + Math.ceil(item.id/6)}><img src={ item.img } alt={ item.alt } /></figure>
        </div>
      </>
  ))

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    setAnimation()
  }, [])

  const loadList = () => {
    setMarker(marker + 6)

    setGroup((pre_click) => pre_click + 1)
    setGroup((pre_click) => {
      setClickAnimation(pre_click)
      return pre_click
    })
  }

  const setClickAnimation = (props) => {
    async function action() {

      gsap.fromTo(
        '.ani2.group' + props + ' img',
        {
          opacity: 0,
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          duration: .8,
          delay: 0.5,
          stagger: 0.2,
          ease: "power1.out",
          scrollTrigger: {
            trigger: '.ani2.group' + props,
            start: 'top 60%',
            end: 'bottom 40%',
            onEnter: () => {
              // console.log('scroll In')
            },
            onEnterBack: () => {
              // console.log('scroll Back')
            },
            // markers: true
          }
        }
      )

      gsap.fromTo(
        '.box.group' + props + ' .head hr',
        {
          opacity: 0,
          height: 0
        },
        {
          opacity: 1,
          height: '100%',
          duration: .6,
          delay: 0.5,
          stagger: 0.2,
          ease: "power1.out",
          scrollTrigger: {
            trigger: '.box.group' + props + ' .head',
            start: 'top 60%',
            end: 'bottom 40%',
            onEnter: () => {
              // console.log('scroll In')
            },
            onEnterBack: () => {
              // console.log('scroll Back')
            },
            // markers: true
          }
        }
      )

    }
    action();

  }

  const setAnimation = () => {
    async function action() {

      gsap.fromTo(
        '.ani2.group1 img',
        {
          opacity: 0,
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          duration: .8,
          delay: 0.5,
          stagger: 0.2,
          ease: "power1.out",
          scrollTrigger: {
            trigger: '.ani2.group1',
            start: 'top 60%',
            end: 'bottom 40%',
            onEnter: () => {
              // console.log('scroll In')
            },
            onEnterBack: () => {
              // console.log('scroll Back')
            },
            // markers: true
          }
        }
      )

      gsap.fromTo(
        '.head hr',
        {
          opacity: 0,
          height: 0
        },
        {
          opacity: 1,
          height: '100%',
          duration: .6,
          delay: 0.5,
          stagger: 0.2,
          ease: "power1.out",
          scrollTrigger: {
            trigger: '.head hr',
            start: 'top 60%',
            end: 'bottom 40%',
            onEnter: () => {
              // console.log('scroll In')
            },
            onEnterBack: () => {
              // console.log('scroll Back')
            },
            // markers: true
          }
        }
      )
    }
    action();

  }

  return (
    <>
      <div className="body">
        <div className="flex">
        {
          // list.slice(0, marker)
          list
        }
        </div>
      </div>
      {
        items.length > marker
          ? <button onClick={loadList} className='btn down'>MORE</button>
          : ''
      }
    </>
  )
}

export default Properites;